import React from 'react';
import {
  Container,
  LogoContainer,
  Title,
  ButtonsContainer,
  Button,
} from './styles';
import Logo from '../../atoms/Logo';
import LogoTopiiBlue from '../../../assets/logos/PoweredByBlue.png';
import LogoTopii from '../../../assets/logos/PoweredByWhite.png';
import {useTranslation} from '../../../context/language';
import {
  APP_STORE,
  GOOGLE_PLAY_STORE,
  LIGHT_THEME,
  DARK_THEME,
} from '../../../utils/constants/';

interface Props {
  theme?: any;
}

const Footer: React.FC<Props> = ({theme}) => {
  const {title} = useTranslation();

  const getLogo = () => {
    switch (theme) {
      case LIGHT_THEME:
        return LogoTopiiBlue;
      case DARK_THEME:
        return LogoTopii;
      default:
        return LogoTopiiBlue;
    }
  };

  return (
    <Container>
      <LogoContainer>
        <Logo src={getLogo()} height={200} width={300} />
      </LogoContainer>
    </Container>
  );
};

export default Footer;
